import { render } from "./VideoTypeList.vue?vue&type=template&id=f59de7a8&scoped=true&ts=true"
import script from "./videoTypeListHelper.ts?vue&type=script&lang=ts"
export * from "./videoTypeListHelper.ts?vue&type=script&lang=ts"

import "./VideoTypeList.vue?vue&type=style&index=0&id=f59de7a8&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f59de7a8"]])

export default __exports__